<template>
  <div class="labels-page">
    <van-nav-bar title="标签选择" left-text="返回" left-arrow @click-left="onClickLeft" />

    <div class="contents">
      <!-- 发送方式选择 -->
      <div class="radio-group">
        <h3>发送方式</h3>
        <van-radio-group v-model="sendType">
          <van-radio name="3">按标签发</van-radio>
          <van-radio name="1">按用户发</van-radio>
          <van-radio name="2">按群发送</van-radio>
        </van-radio-group>
      </div>

      <div class="main-area">
        <!-- 标签组部分 - 仅在按标签发时显示 -->
        <div v-if="sendType === '3'">
          <select-labels :label-categories="labelCategories" @tags-selected="handleTagsSelected" />
        </div>

        <!-- 用户选择组件 - 仅在按用户发时显示 -->
        <div v-if="sendType === '1'">
          <UsersComponent :label-categories="labelCategories" />
        </div>

        <!-- 群组选择组件 - 仅在按群发送时显示 -->
        <div v-if="sendType === '2'">
          <RoomComponent />
        </div>
      </div>


      <div class="button-group">
        <van-button type="primary" block @click="submitForm">确定</van-button>
      </div>

      <van-button style="margin-top: var(--base-px-10);" block type="default" @click="goToSendLog">
        发送任务列表
        <span style="margin-left: 5px; font-size: 16px;">›</span>
      </van-button>
      <van-button style="margin-top: var(--base-px-10);" block @click="syncData">同步标签、用户、群</van-button>
    </div>
  </div>
</template>

<script>
import { getLabelList, syncLabelAndUser } from "../../api/robot.js";
import { Toast } from "vant";
import { mapGetters, mapActions } from "vuex";
// 导入用户页面组件
import UsersComponent from './users.vue';
// 导入标签选择组件
import SelectLabels from './components/selectLabels.vue';
// 导入群组页面组件
import RoomComponent from './components/room.vue';

export default {
  components: {
    SelectLabels,
    UsersComponent,
    RoomComponent
  },
  data() {
    return {
      labelCategories: [],
      sendType: '3', // 默认按标签发（3表示按标签发）
      loading: false
    };
  },
  computed: {
    ...mapGetters('robot', ['selectedUserIds', 'selectedRoomIds'])
  },
  created() {
    this.initPageData();
  },
  methods: {
    ...mapActions('robot', ['setSelectedTagIds']),

    initPageData() {
      // 显示加载中动画
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });

      getLabelList({}).then(res => {
        Toast.clear();
        if (res.code === 1) {
          const rawData = res.data;
          this.labelCategories = rawData.map(group => ({
            id: group.label_id,
            name: group.label_name,
            label_type: group.label_type,
            tags: group.children ? group.children.map(child => ({
              id: child.label_id,
              name: child.label_name,
              group_id: group.label_id
            })) : []
          }));
        } else {
          Toast.fail(res.msg || '获取标签失败');
        }
      }).catch(err => {
        // 清除加载动画
        Toast.clear();
        Toast.fail('获取标签数据失败');
        console.error('获取标签失败:', err);
      })
    },

    // 同步标签和用户
    syncData() {
      Toast.loading({
        message: '同步中...',
        forbidClick: true,
        duration: 0
      });

      syncLabelAndUser({}).then(res => {
        Toast.clear();
        if (res.code === 1) {
          Toast.success('同步成功', { duration: 1500 });
          // 延迟调用initPageData，确保成功提示有足够时间显示
          setTimeout(() => {
            this.initPageData();
          }, 1000);
        } else {
          Toast.fail(res.msg || '同步失败');
        }
      }).catch(err => {
        Toast.clear();
        Toast.fail('请求失败');
        console.error('同步失败:', err);
      });
    },

    // 处理标签选择事件
    handleTagsSelected(tagIds) {
      console.log('接收到选中的标签ID:', tagIds);
      // 存储到vuex中
      this.setSelectedTagIds(tagIds);
    },

    // 跳转到发送任务列表页面
    goToSendLog() {
      this.$router.push({
        path: '/robot/send_log'
      });
    },

    // 返回上一页
    onClickLeft() {
      this.$router.push({
        path: '/'
      });
    },

    // 提交表单
    submitForm() {
      console.log('发送方式:', this.sendType);
      console.log('选中的用户ID:', this.selectedUserIds || []);
      console.log('选中的群组ID:', this.selectedRoomIds || []);

      if (this.sendType == '3') { // 按标签发
        // 从vuex中获取选中的标签ID
        const selectedTagIds = this.$store.state.robot.selectedTagIds || [];

        // 验证是否选择了标签
        if (selectedTagIds.length === 0) {
          Toast.fail('请选择标签');
          return;
        }
      } else if (this.sendType === '1') { // 按用户发
        // 确保selectedUserIds存在且是数组
        if (!this.selectedUserIds || !Array.isArray(this.selectedUserIds)) {
          Toast.fail('用户数据异常');
          return;
        }

        // 验证是否选择了用户
        if (this.selectedUserIds.length === 0) {
          Toast.fail('请选择用户');
          return;
        }
      } else if (this.sendType === '2') { // 按群发送
        // 确保selectedRoomIds存在且是数组
        if (!this.selectedRoomIds || !Array.isArray(this.selectedRoomIds)) {
          Toast.fail('群组数据异常');
          return;
        }

        // 验证是否选择了群组
        if (this.selectedRoomIds.length === 0) {
          Toast.fail('请选择群组');
          return;
        }
      }

      // 构建路由参数 - 传递sendType
      const routeParams = {
        sendType: this.sendType
      };

      console.log('路由参数:', routeParams);

      // 跳转到sender.vue页面
      this.$router.push({
        path: '/robot/sender',
        query: routeParams
      });
    }
  }
};
</script>

<style scoped lang="less">
.labels-page {
  box-sizing: border-box;
  line-height: 1;
  padding-top: 0;
  /* 移除顶部内边距，避免导航栏和内容之间有过大间隙 */
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.contents {
  padding: var(--base-px-20);
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.main-area {
  flex: 1;
  overflow-y: auto;
  margin-bottom: var(--base-px-20);
}

.radio-group {
  margin-bottom: var(--base-px-20);
}

.radio-group h3 {
  color: #333;
  font-size: var(--base-px-16);
  margin-bottom: var(--base-px-10);
}

/* radio组样式 */
.van-radio-group {
  display: flex;
  gap: var(--base-px-20);
}

.van-radio {
  font-size: var(--base-px-14);
}

/* 未选中标签样式 */
.van-tag.tag-unselected {
  background-color: #f5f5f5;
  color: #666;
  border: var(--base-px-1) solid #e5e5e5;
  margin-right: var(--base-px-8);
  margin-bottom: var(--base-px-8);
}

/* 选中标签样式 */
.van-tag.tag-selected {
  background-color: #006eff;
  color: #fff;
  border: var(--base-px-1) solid #006eff;
  margin-right: var(--base-px-8);
  margin-bottom: var(--base-px-8);
}

.button-group {
  margin-top: var(--base-px-10);
}

.van-button {
  width: 100%;
  border-radius: var(--base-px-4);
}

::v-deep .van-button--primary {
  background-color: #006eff;
  border-color: #006eff;
}

/* 无标签数据提示样式 */
.no-data {
  padding: var(--base-px-30) 0;
  margin-top: var(--base-px-10);
}

/* 整体无数据容器样式 */
.no-data-container {
  padding: var(--base-px-60) 0;
  text-align: center;
}
</style>
